import { Space } from 'antd'
import Avatar from 'components/Avatar'
import Button from 'components/Button'
import CalenderStyled from 'components/CalenderStyled'
import Flex from 'components/Flex'
import PlusIcon from 'components/icons/PlusIcon'
import ScheduleList from 'modules/Drive/Partials/ScheduleDriveDrawer/Partials/ScheduleList'
import {
  DriveWrapper,
  HighlitedTag,
  InfoSection,
  LeftSection,
  RightSection,
  SectionWrapper,
  StyledDrawer,
  Title,
} from 'modules/Drive/Partials/ScheduleDriveDrawer/Style/style'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import rolesApi from 'utils/corporateRequest'

const ScheduleDriveDrawer = ({
  scheduleDrawer,
  setScheduleDrawer,
  onConfirmDrawer,
  selectedDrive,
  isReschedule = false,
}) => {
  const [dateQuery, setDateQuery] = useState(
    moment().startOf('month').format('YYYY-MM-DD')
  )
  const [driveList, setDriveList] = useState([])
  const [selectedMonth, setSelectedMonth] = useState(moment().month())
  const instituteId = useSelector(state => state.auth.instituteDetails.id)

  const [calendarValue, setCalendarValue] = useState(
    moment(selectedDrive?.startDate) || moment().unix()
  )
  useEffect(() => {
    scheduleDrawer && getDriveList()
  }, [dateQuery, scheduleDrawer])
  const onDateSelected = date => {
    setCalendarValue(date)
  }

  const closeDrawer = () => {
    setScheduleDrawer(false)
  }
  const onPanelChange = (value, mode) => {
    setSelectedMonth(value.month())
    setDateQuery(moment(value).startOf('month').format('YYYY-MM-DD'))
  }
  const getDriveList = async () => {
    try {
      let list = await rolesApi.get(
        `/corporates/instituteCampus/${instituteId}/drive/list?instituteStatus=CONFIRMED&startDate=${dateQuery}&pageLimit=30`
      )
      setDriveList(list?.data?.result)
    } catch (error) {
      //
    }
  }
  const content = () => {
    return (
      <Fragment>
        <DriveWrapper>
          <Flex spaceBetween centerVertically>
            <Space>
              <Avatar
                background
                src={''}
                size={42}
                IconName={selectedDrive?.corporate?.name?.split('')?.[0]}
                font={18}
              />
              <InfoSection>
                <Title>
                  <HighlitedTag>
                    ‘{selectedDrive?.corporate?.name}’
                  </HighlitedTag>{' '}
                  has requested for a{' '}
                  <HighlitedTag>
                    ‘{selectedDrive?.driveMode?.replace('_', ' ').toLowerCase()}
                    ’
                  </HighlitedTag>
                  . Please schedule a date to confirm the drive.
                </Title>
              </InfoSection>
            </Space>
            <Button.Primary
              icon={<PlusIcon />}
              text="Schedule"
              onClick={() => {
                onConfirmDrawer(calendarValue)
              }}
            />
          </Flex>
        </DriveWrapper>
        <SectionWrapper>
          <LeftSection>
            <CalenderStyled
              calendarValue={calendarValue}
              setSelected={onDateSelected}
              onPanelChange={onPanelChange}
              driveList={driveList}
              selectedMonth={selectedMonth}
            />
          </LeftSection>
          <RightSection>
            <ScheduleList
              date={moment(calendarValue * 1000).format('DD-MM-YYYY')}
            />
          </RightSection>
        </SectionWrapper>
      </Fragment>
    )
  }

  return (
    <StyledDrawer
      title={<h3>{isReschedule ? 'Reschedule Drive' : 'Schedule Drive'}</h3>}
      placement="right"
      closable={true}
      onClose={closeDrawer}
      visible={scheduleDrawer}
      content={content()}
      width="80%"
    />
  )
}

export default ScheduleDriveDrawer
